import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppFloat = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  // WhatsApp configuration
  const whatsappNumber = '393939587340'; // +39 393 9587340 without the +
  const predefinedMessage = 'Vorrei info sul IlTuoAmaro.it';
  const encodedMessage = encodeURIComponent(predefinedMessage);
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

  const handleWhatsAppClick = () => {
    // Open WhatsApp in a new window/tab
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {/* WhatsApp Float Button */}
      <div className="whatsapp-float-container">
        <button
          onClick={handleWhatsAppClick}
          onMouseEnter={() => {
            setIsHovered(true);
            setIsTooltipVisible(true);
          }}
          onMouseLeave={() => {
            setIsHovered(false);
            setTimeout(() => setIsTooltipVisible(false), 300);
          }}
          className={`whatsapp-float-button ${isHovered ? 'hovered' : ''}`}
          title="Contattaci su WhatsApp"
        >
          <MessageCircle className="w-8 h-8" />
          
          {/* Pulse animation rings */}
          <div className="whatsapp-pulse-ring whatsapp-pulse-ring-1"></div>
          <div className="whatsapp-pulse-ring whatsapp-pulse-ring-2"></div>
          <div className="whatsapp-pulse-ring whatsapp-pulse-ring-3"></div>
        </button>

        {/* Tooltip */}
        {isTooltipVisible && (
          <div className="whatsapp-tooltip">
            <div className="whatsapp-tooltip-content">
              <div className="flex items-center justify-between mb-2">
                <span className="font-semibold text-green-800">Hai bisogno di aiuto?</span>
              </div>
              <p className="text-sm text-green-700 mb-3">
                Scrivici su WhatsApp per informazioni sui nostri liquori personalizzati!
              </p>
              <div className="flex items-center text-xs text-green-600">
                <MessageCircle className="w-3 h-3 mr-1" />
                <span>+39 393 9587340</span>
              </div>
            </div>
            <div className="whatsapp-tooltip-arrow"></div>
          </div>
        )}
      </div>

      {/* CSS Styles */}
      <style>{`
        .whatsapp-float-container {
          position: fixed;
          bottom: 100px;
          right: 45px;
          z-index: 1000;
        }

        .whatsapp-float-button {
          position: relative;
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #25D366 0%, #20BC5A 100%);
          border: none;
          border-radius: 50%;
          color: white;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
        }

        .whatsapp-float-button:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 15px 35px rgba(37, 211, 102, 0.6);
        }

        .whatsapp-float-button.hovered {
          background: linear-gradient(135deg, #20BC5A 0%, #1BA94D 100%);
        }

        /* Pulse animation rings */
        .whatsapp-pulse-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border: 2px solid rgba(37, 211, 102, 0.5);
          border-radius: 50%;
          animation: whatsapp-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        .whatsapp-pulse-ring-1 {
          width: 80px;
          height: 80px;
          animation-delay: 0s;
        }

        .whatsapp-pulse-ring-2 {
          width: 100px;
          height: 100px;
          animation-delay: 0.7s;
        }

        .whatsapp-pulse-ring-3 {
          width: 120px;
          height: 120px;
          animation-delay: 1.4s;
        }

        @keyframes whatsapp-pulse {
          0% {
            transform: translate(-50%, -50%) scale(0.8);
            opacity: 1;
          }
          100% {
            transform: translate(-50%, -50%) scale(1.8);
            opacity: 0;
          }
        }

        /* Tooltip styles */
        .whatsapp-tooltip {
          position: absolute;
          bottom: 80px;
          right: 0;
          background: white;
          border: 1px solid rgba(37, 211, 102, 0.2);
          border-radius: 12px;
          padding: 0;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
          width: 280px;
          animation: whatsapp-tooltip-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          transform-origin: bottom right;
        }

        .whatsapp-tooltip-content {
          padding: 16px;
          background: linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 100%);
          border-radius: 12px;
        }

        .whatsapp-tooltip-arrow {
          position: absolute;
          bottom: -8px;
          right: 20px;
          width: 16px;
          height: 16px;
          background: white;
          border: 1px solid rgba(37, 211, 102, 0.2);
          border-top: none;
          border-left: none;
          transform: rotate(45deg);
        }

        @keyframes whatsapp-tooltip-in {
          0% {
            opacity: 0;
            transform: scale(0.8) translateY(10px);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        /* Mobile responsive */
        @media (max-width: 768px) {
          .whatsapp-float-container {
            bottom: 90px;
            right: 20px;
          }

          .whatsapp-float-button {
            width: 60px;
            height: 60px;
          }

          .whatsapp-tooltip {
            width: 260px;
            right: 0;
          }

          .whatsapp-pulse-ring-1 {
            width: 70px;
            height: 70px;
          }

          .whatsapp-pulse-ring-2 {
            width: 90px;
            height: 90px;
          }

          .whatsapp-pulse-ring-3 {
            width: 110px;
            height: 110px;
          }
        }

        @media (max-width: 480px) {
          .whatsapp-tooltip {
            width: 240px;
            right: 0;
          }
        }

        /* Accessibility */
        .whatsapp-float-button:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.3);
        }

        /* Ensure tooltip is above other elements */
        .whatsapp-tooltip {
          z-index: 1001;
        }
      `}</style>
    </>
  );
};

export default WhatsAppFloat;